export enum ResourceTypes {
  LEADS = 'Leads',
  CAMPAIGNS = 'campaigns',
  LOCAL_PRESENCE_DIDS = 'local-presence-dids',
  PAYMENT_CLEARANCE = 'payment-clearance',
}
